import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { SmartContext } from '../../../library/Core/SmartContext';
import { axiosClient } from '../../../library/Service/axiosClient';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';

const CommitmentPaths = () => {
    const { state } = useContext(SmartContext);
    const { id } = useParams<{ id: string }>();
    const [selectedGoals, setSelectedGoals] = useState<string[]>([]);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const domain = state?.domain || new Map();
    const pathwayGoals = domain.get('PATHWAY_GOAL') || [];

    useEffect(() => {
        const load = async () => {
            try {
                const res = await axiosClient().get(`${process.env.REACT_APP_ADMIN_API_SERVER}/institute/${id}/commitment-config`);
                const data = res?.data?.data;
                if (data?.pathwayGoals && Array.isArray(data.pathwayGoals)) {
                    setSelectedGoals(data.pathwayGoals);
                }
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }
        };
        load();
    }, [id]);

    const toggleGoal = (code: string) => {
        setSelectedGoals(prev =>
            prev.includes(code) ? prev.filter(c => c !== code) : [...prev, code]
        );
    };

    const handleSave = async () => {
        setSaving(true);
        try {
            const res = await axiosClient().post(`${process.env.REACT_APP_ADMIN_API_SERVER}/institute/${id}/commitment-config`, {
                pathwayGoals: selectedGoals
            });
            if (res?.data?.success) {
                Swal.fire({
                    title: 'Success!',
                    text: 'Commitment paths saved successfully.',
                    icon: 'success',
                    showConfirmButton: false,
                    timer: 1500,
                    timerProgressBar: true
                });
            } else {
                toast.error('Failed to save commitment paths');
            }
        } catch (e) {
            console.error(e);
            toast.error('Save failed');
        } finally {
            setSaving(false);
        }
    };

    if (loading) return <div className="p-4 text-center">Loading...</div>;

    return (
        <div className="p-3">
            <h5 className="mb-3">Select goals you want success managers to capture for your alumni</h5>
            {pathwayGoals.length === 0 && (
                <div className="alert alert-warning">No PATHWAY_GOAL domain values found. Please configure domain data first.</div>
            )}
            <div className="row g-3">
                {pathwayGoals.map((goal: any) => (
                    <div key={goal.code} className="col-md-4">
                        <div
                            className={`card h-100 cursor-pointer ${selectedGoals.includes(goal.code) ? 'border-primary' : ''}`}
                            onClick={() => toggleGoal(goal.code)}
                            style={{ cursor: 'pointer' }}
                        >
                            <div className="card-body">
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={selectedGoals.includes(goal.code)}
                                        onChange={() => toggleGoal(goal.code)}
                                        onClick={e => e.stopPropagation()}
                                    />
                                    <label className="form-check-label fw-bold">{goal.value}</label>
                                </div>
                                {goal.blurb && <small className="text-muted d-block mt-1">{goal.blurb}</small>}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <div className="mt-4">
                <button className="btn btn-success" onClick={handleSave} disabled={saving}>
                    {saving ? 'Saving...' : 'Save'}
                </button>
            </div>
        </div>
    );
};

export default CommitmentPaths;
